import { mapActions, mapState } from 'vuex';
import { POST_LOADER_DELAY, countries } from '@/constants';
import ChromeEditor from '@/components/chrome/Editor.vue';
import ChromeEditorPanel from '@/components/chrome/EditorPanel.vue';
import FieldBase from '@/components/field/Base.vue';
import PricingTable from '@/components/PricingTable.vue';
import PillContent from '@/components/pill/PillContent.vue';
import SidebarPanel from '@/components/sidebar/SidebarPanel.vue';
import messages from '../../messages';
import { askDelete, createRecord } from '../../common';
import VendorResource from './VendorResource.vue';

export default (storeName: string) => ({
  data: () => ({
    fetched: false,
    settings: {
      name: {
        title: 'Name',
      },
      notes: {
        title: 'Notes',
        type: 'textarea',
        params: {
          newline: true,
        },
      },
      contact: {
        title: 'Contact Details',
        type: 'multi',
        params: {
          fields: {
            address: {
              title: 'Address',
            },
            country: {
              title: 'Country',
              type: 'dropdown',
              params: {
                title: 'Select country',
                values: countries,
              },
            },
            email: {
              title: 'Email',
              type: 'text',
              params: {
                attributes: {
                  type: 'email',
                },
              },
            },
            phoneNumber: {
              title: 'Phone',
            },
            website: {
              title: 'Website',
              type: 'text',
              params: {
                attributes: {
                  type: 'url',
                },
              },
            },
          },
        },
      },
    },
  }),
  computed: {
    ...mapState('chromeEditor', ['panel']),
    ...mapState(storeName, ['data', 'resources']),
    address(): string|void {
      const { address, country: countryCode } = this.contact;
      const country = countryCode && (countries as any)[countryCode];
      if (address && country)  {
        return `${address}, ${country}`;
      } else if (address) {
        return address;
      } else if (country) {
        return country;
      }
    },
    contact() {
      return this.data.contact;
    },
    markedNotes(): string {
      return this.$markdown(this.data.notes || '');
    },
    vendorId() {
      return this.$route.params.vendorId;
    },
  },
  methods: {
    createRecord,
    ...mapActions('chromeEditor', ['selectPanel']),
    ...mapActions(storeName, [
      'create',
      'load',
    ]),
    askDelete() {
      const { id, name } = this.data;
      askDelete
        .bind(this)(id, name)
        .then((deleted: boolean) => (
          deleted && this.$router.push({
            name: 'vendors',
          })
        ));
    },
    async fetchData() {
      // load data, populate
      return await this.load(this.vendorId);
    },
    print() {
      window.print();
    },
    selectRef(name: string) {
      this.selectPanel('info');

      // wait for animation to finish before focusing on element
      setTimeout(() => {
        const { $el } = this.$refs[name][0];
        $el.querySelector('input,textarea').focus();
      }, 500);
    },
    save() {
      const promise = this.$store
        .dispatch(`${storeName}/save`)
        .catch((error: any) => {
          console.error(error);

          this.$store.commit('dialog/CREATE', {
            title: 'Save error',
            content: messages.ERROR_VENDOR_SAVE,
            compact: true,
            delay: POST_LOADER_DELAY,
            buttons: [{
              text: 'Close',
              click: (message: any) => message.close(),
            }],
          });
        });

      this.$store.commit('loader/ADD', {
        title: 'Saving',
        promise,
      });
    },
  },
  components: {
    ChromeEditor,
    ChromeEditorPanel,
    FieldBase,
    PillContent,
    PricingTable,
    SidebarPanel,
    VendorResource,
  },
} as IView);
